import script from "./SelectBrandsStepTwo.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectBrandsStepTwo.vue?vue&type=script&setup=true&lang=js"

import "./SelectBrandsStepTwo.vue?vue&type=style&index=0&id=11a2705e&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11a2705e"]])

export default __exports__